import AuditLog from "@/components/AuditLog";

const AuditLogPage = () => (
  <section className="space-y-6">
    <header>
      <h1 className="heading-display text-2xl">Audit Log</h1>
      <p className="mt-1 text-sm text-muted-foreground">Review administrative and security-related activity.</p>
    </header>
    <AuditLog />
  </section>
);

export default AuditLogPage;
